export const GTMActionTypes = {
  EVENT_PAGE_EVENT_LOADED_GTM: 'EVENT_PAGE_EVENT_LOADED_GTM',
};
